// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"3185":"7a3d48410b799f56","6042":"625f5730bcd62d7a"}[chunkId] + ".css";
};